// extracted by mini-css-extract-plugin
export default {"backgroundWrapper":"cta-block-module--backgroundWrapper--bb328","contentWrapper":"cta-block-module--contentWrapper--8ff1f"};